// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__z_L0x"};